<span *ngIf="status && label" class="status-badge membership-status-badge membership-status-badge--{{ status | lowercase }}">
  {{ label }}
</span>
